export enum CartProductTypeEnum {
    DEFAULT = "default",
    BRAND_OFFER = "brand_offer",
    COMBO = "combo",
    SUGGESTED = "suggested"
  }

